export const buildRelatedPriceListsQuery = ({
  categoryId,
  priceValue,
  beneficiaryCompanyKey,
  providerKey,
}) => {
  const query = {
    CategoryId: categoryId,
    ...(beneficiaryCompanyKey
      ? { BeneficiaryCompanyKey: beneficiaryCompanyKey }
      : { HasNoBeneficiaryCompany: true }),
  };

  if (priceValue !== undefined && priceValue !== null) {
    query.PriceValue = priceValue;
  }

  if (providerKey) {
    query.ProviderKey = providerKey;
  }

  return query;
};

export const getProviderRecordFromPriceList = (priceList, providerKey) => {
  return priceList?.priceListProviders?.find(
    record =>
      record?.provider?.providerKey === providerKey,
  );
};

export const filterMatchingPriceListsForSync = (
  priceLists,
  { sourcePriceListId, sourceHealthPlanId },
) =>
  priceLists?.filter(
    item =>
      item.id !== Number(sourcePriceListId) &&
      item.healthPlanId !== Number(sourceHealthPlanId),
  ) || [];
